import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  duplicate(event) {
    event.preventDefault()
    event.target.innerText = "Duplicating..."

    $.ajax({
      url: `/forms/${event.params.id}/duplicate`,
      type: "POST",
      success: function() {
        document.cookie = "flash_notice=Form duplicated; path=/"
        window.location.reload()
      },
      error: function() {
        event.target.innerText = "Error"
      },
    })
  }
}
